import o from "./isSerializedAPIError.mjs";
import e from "./isCodedError.mjs";
import i from "./isSerializedCodedError.mjs";
import "axios";
import "@ancon/wildcat-types";
function p(r) {
  if (o(r) || o(r))
    return r.response.data.errorCode;
  if (e(r) || i(r))
    return r.code;
  throw new Error("Could not resolve error code");
}
export {
  p as default
};
